import React from "react";
import { Link } from "react-router-dom";
import SEOHead from "../../components/SEO/SEOHead";

const FoundersNote = () => {
  return (
    <>
      <SEOHead
        title="Founder's Note - Bowling Tournament App"
        description="Meet Joe P., the founder of Bowling Tournament App. From bowling alley employee to engineer, and why he built bowling tournament software directors can run in the open."
        canonicalUrl="/founders-note"
      />

      <div className="min-h-screen bg-brand-cream py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="heading-display text-4xl mb-4">From the Founder</h1>
            <div className="w-24 h-1 bg-brand-gold mx-auto"></div>
          </div>

          <div className="card-board p-8 md:p-12">
            <div className="prose prose-lg max-w-none">
              <p className="text-lg text-brand-charcoal leading-relaxed mb-6">
                I didn't grow up bowling—but I did grow up in a bowling alley.
              </p>

              <p className="text-brand-muted leading-relaxed mb-6">
                I got my first job at one in high school. I didn't have a clue
                how to bowl, but I instantly fell in love with the technical
                side of the sport—and free bowling made it easy to practice. I
                did manage to get a 300 eventually, but what really hooked me,
                were the machines. We had old Brunswick A1 pinsetters with A2
                conversion kits, originally designed with help from Otis
                Elevator back in the day. I was fascinated by how they worked.
                That curiosity led me to pursue a degree in mechanical
                engineering at California State University, Chico, where I
                graduated in 2015.
              </p>

              <p className="text-brand-muted leading-relaxed mb-6">
                I worked at that same bowling center throughout college (and for
                a bit after)—nearly 10 years in total.
              </p>

              <p className="text-brand-muted leading-relaxed mb-6">
                After school, I joined SolarCity, which was later acquired by
                Tesla. There, I grew into process engineering and discovered a
                passion for software development. I continue to work at Tesla
                today, where I combine hands-on systems thinking with automation
                and software tools.
              </p>

              <p className="text-brand-muted leading-relaxed mb-6">
                In the 2017-2018 season, I became president of my local bowling
                association. We run three tournaments a year, and I quickly
                found myself frustrated by the limitations of spreadsheets.
                Excel tools were useful but clunky—hard to maintain, hard to
                share, and definitely not transparent for bowlers. I wanted
                something better: a simpler, more open way to run tournaments
                and share results.
              </p>

              <p className="text-brand-muted leading-relaxed mb-6">
                After a few false starts, I began building this app at the end
                of 2024. My goal is to make tournament management easier for
                directors and more transparent for everyone who bowls—even if
                they're watching from home.
              </p>

              <p className="text-brand-charcoal leading-relaxed mb-6">
                This platform represents my commitment to the bowling
                community—a way to give back to the sport that has given me so
                much. Whether you're a tournament director looking for better
                tools, a bowler wanting to stay connected, or someone just
                discovering the joy of bowling, I hope this app helps make your
                experience a little bit better.
              </p>

              <p className="text-brand-muted leading-relaxed mb-8">
                Bowling Tournament App is bowling tournament software for the
                jobs that used to live in a spreadsheet: signups, squads,
                scoring, and payouts, on a board bowlers can see.
              </p>

              <div className="border-l-4 border-brand-gold pl-6 py-4 bg-brand-cream rounded-r-lg">
                <p className="text-brand-charcoal font-medium">— Joe P.</p>
              </div>
            </div>
          </div>

          <div className="text-center mt-8">
            <Link
              to="/"
              className="inline-flex items-center text-brand-gold-ink hover:text-brand-charcoal transition-colors"
            >
              <svg
                className="w-4 h-4 mr-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M10 19l-7-7m0 0l7-7m-7 7h18"
                />
              </svg>
              Back to Home
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default FoundersNote;
